module.exports = __webpack_public_path__ + "3a08a7670c644d2e129041cd809cca97.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/student-owl.png
// module id = 530
// module chunks = 0